module.exports = __webpack_public_path__ + "media/bootstrap-icons/eyeglasses-3ce09fe5.svg";